const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function parseGiftCardAmount(value: string | number | null | undefined): number {
  if (value == null) return 0
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }
  const trimmed = value.trim()
  if (!trimmed) return 0
  const parsed = Number(trimmed.replace(/[$,\s]/g, ''))
  return Number.isFinite(parsed) ? parsed : 0
}

/** Format a money field for editing: always $#,##0.00. */
export function formatGiftCardAmountInput(value: string | number | null | undefined): string {
  return currencyFmt.format(parseGiftCardAmount(value))
}
